// Hooks
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// Reduz
import { login, reset } from '../../slices/authSlice';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button, Card, CardHeader, Input, Typography } from '@material-tailwind/react';
import { useForm } from 'react-hook-form';
import usePageTitle from '../../hook/usePageTitle';

const Login = () => {
  usePageTitle();

  const { register, handleSubmit } = useForm();
  const [captchaValid, setCaptchaValid] = useState(false);
  const dispatch = useDispatch();

  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaValid(true);
    } else {
      setCaptchaValid(false);
    }
  };

  const { loading, error, success, theme } = useSelector((state) => state.auth);

  const onSubmit = (data) => {
    if (!captchaValid) {
      alert('Por favor, complete o reCAPTCHA.');
      return;
    }
    const user = {
      username: data.username.toLowerCase(),
      password: data.password,
    };
    dispatch(login(user));
  };

  useEffect(() => {
    dispatch(reset());
  }, []);

  return (
    <section className="md:px-8 bg-lightMenu  dark:bg-darkColorBg w-full">
      <div className="  mx-auto h-screen grid place-items-center">
        <Card shadow={false} className="md:px-24 md:py-14 py-8 border border-gray-300  px-3 mx-3">
          <CardHeader shadow={false} floated={false} className="text-center ">
            <Typography variant="h1" className="mb-4 !text-3xl lg:text-4xl text-blue-800">
              Login
            </Typography>
          </CardHeader>
          <form
            action="#"
            className="flex flex-col gap-4 md:mt-12"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div>
              <Input
                label="Usuario"
                id="usuario"
                color="gray"
                size="lg"
                type="text"
                name="text"
                placeholder="usuario"
                {...register('username', { required: true })}
              />
            </div>
            <div>
              <Input
                label="Senha"
                id="usuario"
                color="gray"
                size="lg"
                type="password"
                name="text"
                placeholder="senha"
                {...register('password', { required: true })}
              />
            </div>
            <div className="w-full overflow-auto">
              <ReCAPTCHA
                // size="normal"
                sitekey="6LdWLo4qAAAAAPrpJG608JT3r1BnZn5AGiJGNplR" // Substitua pela sua chave do site
                onChange={handleCaptchaChange}
              />
            </div>
            {!loading && (
              <Button size="lg" color="gray" fullWidth type="submit" className="bg-blue-800">
                ENTRAR
              </Button>
            )}
            {loading && (
              <Button
                size="lg"
                color="gray"
                fullWidth
                type="submit"
                disabled
                className="bg-blue-800"
              >
                ENTRAR
              </Button>
            )}
          </form>
          {error && (
            <Typography variant="h5" color="red">
              Usuário e/ou senha incorreto(s)
            </Typography>
          )}
        </Card>
      </div>
    </section>
  );
};

export default Login;
